import * as React from "react";
const SplashTicket: React.FC<any> = props => {
  return (
    <div className="splashFull">
      <a rel="dofollow" href="https://teatr.torun.pl/">
        <img
          src="/images/logo.svg"
          className="splashLogo"
          alt="Teatr Horzycy Logo"
        />
      </a>
      <p className="mt-5">Bilet został zakupiony.</p>
      <p>Sprawdź swój e-mail aby pobrać bilet (Sprawdź również folder spam).</p>
    </div>
  );
};

export default SplashTicket;
